import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';

/**
 * Error component fallback whne sidnav is unable to load.
 *
 * @returns Fallback component
 */
export default function SideNavError() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div>För tillfället går det inte att visa någon information. Vänligen försök igen senare.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}